import {Theme} from '@lookiero/aurora';
import StyleSheet from 'react-native-extended-stylesheet';

const {borderWidth2, space05, space2, space4, space12, colorBgInteractiveSelected} = Theme.get();

export const style = StyleSheet.create({
  wrapper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  personalShopperInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: space2,
    width: '100%',
  },
  imageContainer: {
    padding: space05,
    borderColor: colorBgInteractiveSelected,
    borderWidth: borderWidth2,
    borderRadius: space12,
    marginRight: space4,
    overflow: 'hidden',
  },
  image: {
    width: 56,
    height: 56,
    borderRadius: space12,
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    paddingTop: space4,
    width: '100%',
  },
});
